export const filterNonNullObjectValues = (obj: any) => {
    let newObj = {};
    for (let key in obj) {
        if (obj[key] !== null) {
            //@ts-ignore
            newObj[key!] = obj[key];
        }
    }
    return newObj;
}